import React from "react";

import { TicketContext } from "../../components/TicketProvider";

/**
 * Hook to access the TicketContext value.
 *
 * @returns The TicketContext value.
 * @throws Will throw an error if used outside of a TicketContext provider.
 * @example
 * const ticket = useTicket();
 */
function useTicket() {
  const ticket = React.useContext(TicketContext);

  if (ticket === undefined) {
    throw new Error("useTicket must be used within a TicketContext provider.");
  }

  return ticket;
}

export default useTicket;
